(function () {
  'use strict';

  var PACK_SIZES = ['3-Pack', '6-Pack', '12-Pack'];
  var FISH_FAMILY_TAGS = ['Sardines', 'Mackerel', 'codfish'];
  var FLAVOR_TAGS = ['EVOO', 'Lemon', 'Smoke', 'Piri-Piri', 'Tomato'];

  var catalog = [];
  var slot = null;

  function init() {
    var el = document.querySelector('[data-cart-suggestions]');
    if (!el) return;
    try {
      catalog = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }

    window.addEventListener('shapes:cart:afteradditem', function () { evaluate(); });
    window.addEventListener('shapes:cart:cartqtychange', function () { evaluate(); });
    window.addEventListener('shapes:cart:update', function () { evaluate(); });

    resolveSlot();
  }

  /**
   * The cart drawer markup lives inside a <template data-should-teleport>
   * that is moved into the live DOM on idle by the theme's initTeleport.
   * We cannot query for elements inside the template — they are in a
   * DocumentFragment. Use a MutationObserver to detect when [data-cart-drawer]
   * appears in the live DOM, then create and insert the slot div.
   */
  function resolveSlot() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      insertSlot(drawer);
      return;
    }

    var observer = new MutationObserver(function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) {
        observer.disconnect();
        insertSlot(drawer);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function insertSlot(drawer) {
    var cartFooter = drawer.querySelector('[data-cart-footer]');
    if (!cartFooter) return;
    var footerWrapper = cartFooter.parentElement;
    if (!footerWrapper) return;
    var container = footerWrapper.parentElement;
    if (!container) return;
    slot = document.createElement('div');
    slot.id = 'cart-suggestions-slot';
    container.insertBefore(slot, footerWrapper);
    evaluate();
  }

  function evaluate() {
    if (!slot) return;
    fetch(window.theme.routes.cart_url + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { clear(); });
  }

  function clear() {
    if (slot) slot.innerHTML = '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- helpers ---- */

  function cartProductIds(cart) {
    var ids = {};
    for (var i = 0; i < cart.items.length; i++) {
      ids[cart.items[i].product_id] = true;
    }
    return ids;
  }

  function findInCatalog(productId) {
    for (var i = 0; i < catalog.length; i++) {
      if (catalog[i].id === productId) return catalog[i];
    }
    return null;
  }

  function getPackSizeFromItem(item) {
    if (!item.options_with_values) return null;
    for (var i = 0; i < item.options_with_values.length; i++) {
      if (item.options_with_values[i].name === 'Pack Size') {
        return item.options_with_values[i].value;
      }
    }
    return null;
  }

  function packSizeIndex(size) {
    return PACK_SIZES.indexOf(size);
  }

  function getTags(tagList, allowed) {
    var out = [];
    for (var i = 0; i < tagList.length; i++) {
      if (allowed.indexOf(tagList[i]) !== -1) out.push(tagList[i]);
    }
    return out;
  }

  /**
   * Find up to 1 tin candidate from the same fish family with a
   * different flavor tag. Used by R2 step (a).
   */
  function findTinCandidates(pool, cartProductId, inCart, family, flavors, cartPackSize, sameFamily) {
    var out = [];
    for (var i = 0; i < pool.length; i++) {
      var c = pool[i];
      if (c.id === cartProductId) continue;
      if (inCart[c.id]) continue;
      if (c.productType !== 'tinned fish') continue;

      var cFamily = getTags(c.tags, FISH_FAMILY_TAGS);
      var hasSharedFamily = false;
      for (var f = 0; f < family.length; f++) {
        if (cFamily.indexOf(family[f]) !== -1) { hasSharedFamily = true; break; }
      }
      if (sameFamily && !hasSharedFamily) continue;
      if (!sameFamily && hasSharedFamily) continue;

      var cFlavors = getTags(c.tags, FLAVOR_TAGS);
      var hasDifferent = false;
      for (var fl = 0; fl < cFlavors.length; fl++) {
        if (flavors.indexOf(cFlavors[fl]) === -1) { hasDifferent = true; break; }
      }
      if (!hasDifferent) continue;

      var variant = pickVariant(c, cartPackSize);
      if (!variant) continue;

      out.push({ product: c, variant: variant });
      if (out.length >= 1) break;
    }
    return out;
  }

  /**
   * Pick the best variant for a candidate product, matching or
   * exceeding the cart item's pack size. Never downsell.
   * Skip candidates with multi-value options other than Pack Size.
   */
  function pickVariant(candidate, targetPackSize) {
    if (candidate.optionCount > 1) return null;

    var variants = candidate.variants;
    if (!targetPackSize) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i];
      }
      return null;
    }

    var targetIdx = packSizeIndex(targetPackSize);
    if (targetIdx === -1) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i];
      }
      return null;
    }

    // Try exact match first, then go UP in size. Never go down.
    for (var s = targetIdx; s < PACK_SIZES.length; s++) {
      for (var v = 0; v < variants.length; v++) {
        if (variants[v].packSize === PACK_SIZES[s] && variants[v].available) {
          return variants[v];
        }
      }
    }
    return null;
  }

  function pickFirstAvailableVariant(candidate) {
    if (candidate.optionCount > 1) return null;
    for (var i = 0; i < candidate.variants.length; i++) {
      if (candidate.variants[i].available) return candidate.variants[i];
    }
    return null;
  }

  /* ---- cart API ---- */

  function addToCart(variantId, callback) {
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-items,cart-footer,cart-item-count', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: { response: resp }
        }));
        if (callback) callback();
      })
      .catch(function () {});
  }

  function changeLineItem(lineKey, sellingPlanId, callback) {
    fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, selling_plan: sellingPlanId, sections: 'cart-items,cart-footer,cart-item-count', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        document.body.dispatchEvent(new CustomEvent('shapes:cart:cartqtychange', {
          bubbles: true,
          detail: {
            response: resp,
            key: lineKey,
            quantity: null,
            previousQuantity: null,
            variantId: null,
            originalTarget: null
          }
        }));
        if (callback) callback();
      })
      .catch(function () {});
  }

  /* ---- rules engine ---- */

  function render(cart) {
    if (!slot) return;

    // R0 — suppress if cart is empty
    if (!cart.items || cart.items.length === 0) {
      clear();
      return;
    }

    var inCart = cartProductIds(cart);

    // R1 — Subscription upsell
    var r1 = evaluateR1(cart, inCart);
    if (r1) { renderR1(r1); return; }

    // R2 — Flavor discovery
    var r2 = evaluateR2(cart, inCart);
    if (r2) { renderR2(r2); return; }

    // R3 — Merch
    var r3 = evaluateR3(cart, inCart);
    if (r3) { renderR3(r3); return; }

    // No rule matched
    clear();
  }

  /* ---- R1: Subscription ---- */

  function evaluateR1(cart, inCart) {
    // Check: no line already has a selling plan
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].selling_plan_allocation) return null;
    }

    // Find the highest-value pack line with a selling plan.
    // When multiple qualifying lines exist (e.g. 12-Pack and 6-Pack),
    // convert the one with the greatest line value.
    var best = null;
    var bestValue = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var ps = getPackSizeFromItem(cart.items[i]);
      if (ps !== '6-Pack' && ps !== '12-Pack') continue;

      var entry = findInCatalog(cart.items[i].product_id);
      if (!entry || !entry.sellingPlanId) continue;

      var lineValue = cart.items[i].final_line_price || cart.items[i].line_price || 0;
      if (!best || lineValue > bestValue) {
        best = {
          lineKey: cart.items[i].key,
          sellingPlanId: entry.sellingPlanId,
          packSize: ps
        };
        bestValue = lineValue;
      }
    }
    return best;
  }

  function renderR1(data) {
    var packNote = data.packSize ? ' Applies to your ' + data.packSize + '.' : '';
    var html = '<div data-suggestion-r1>' +
      '<p>Make it a standing order</p>' +
      '<button data-suggestion-subscribe data-line-key="' + data.lineKey +
        '" data-selling-plan="' + data.sellingPlanId + '">SWITCH TO MONTHLY</button>' +
      '<p>5% off, delivered monthly.' + packNote + '</p>' +
      '</div>';
    slot.innerHTML = html;

    var btn = slot.querySelector('[data-suggestion-subscribe]');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.disabled = true;
      changeLineItem(data.lineKey, data.sellingPlanId);
    });
  }

  /* ---- R2: Flavor discovery ---- */

  function evaluateR2(cart, inCart) {
    // Exactly one line item, qty 1 or 2, tinned fish
    if (cart.items.length !== 1) return null;
    var item = cart.items[0];
    if (item.product_type !== 'tinned fish') return null;
    if (item.quantity !== 1 && item.quantity !== 2) return null;

    // Look up the cart item in catalog to get tags
    var entry = findInCatalog(item.product_id);
    if (!entry) return null;

    var family = getTags(entry.tags, FISH_FAMILY_TAGS);
    if (family.length === 0) return null;

    var flavors = getTags(entry.tags, FLAVOR_TAGS);

    var cartPackSize = getPackSizeFromItem(item);

    // (a) Same fish family, different flavor
    var candidates = findTinCandidates(catalog, item.product_id, inCart, family, flavors, cartPackSize, true);

    // (b) Cross-family fallback — different family, prefer shared flavor
    if (candidates.length === 0) {
      var sharedFlavor = [];
      var otherCross = [];
      for (var i = 0; i < catalog.length; i++) {
        var c = catalog[i];
        if (c.id === item.product_id) continue;
        if (inCart[c.id]) continue;
        if (c.productType !== 'tinned fish') continue;

        var cFamily = getTags(c.tags, FISH_FAMILY_TAGS);
        // Must be a DIFFERENT family
        var sameFamily = false;
        for (var f = 0; f < family.length; f++) {
          if (cFamily.indexOf(family[f]) !== -1) { sameFamily = true; break; }
        }
        if (sameFamily) continue;

        var variant = pickVariant(c, cartPackSize);
        if (!variant) continue;

        // Sort by whether candidate shares a flavor tag with the cart item
        var cFlavors = getTags(c.tags, FLAVOR_TAGS);
        var shares = false;
        for (var fl = 0; fl < flavors.length; fl++) {
          if (cFlavors.indexOf(flavors[fl]) !== -1) { shares = true; break; }
        }
        if (shares) {
          sharedFlavor.push({ product: c, variant: variant });
        } else {
          otherCross.push({ product: c, variant: variant });
        }
      }
      candidates = sharedFlavor.concat(otherCross).slice(0, 1);
    }

    if (candidates.length === 0) return null;
    return candidates;
  }

  function renderR2(candidates) {
    var html = '<div data-suggestion-r2><p>Round out the rotation</p>';
    for (var i = 0; i < candidates.length; i++) {
      html += buildTile(candidates[i].product, candidates[i].variant);
    }
    html += '</div>';
    slot.innerHTML = html;
    bindAddButtons();
  }

  /* ---- R3: Merch ---- */

  function evaluateR3(cart, inCart) {
    var hasTinOrMulti = false;
    var hasMerch = false;

    for (var i = 0; i < cart.items.length; i++) {
      var pt = cart.items[i].product_type;
      if (pt === 'tinned fish' || pt === 'Multipacks') hasTinOrMulti = true;
      if (pt === 'Merch') hasMerch = true;
    }

    if (!hasTinOrMulti || hasMerch) return null;

    // Find first merch candidate not already in cart
    for (var i = 0; i < catalog.length; i++) {
      var c = catalog[i];
      if (c.productType !== 'Merch') continue;
      if (inCart[c.id]) continue;

      var variant = pickFirstAvailableVariant(c);
      if (!variant) continue;

      return [{ product: c, variant: variant }];
    }
    return null;
  }

  function renderR3(candidates) {
    var html = '<div data-suggestion-r3><p>Goes with it</p>';
    html += buildTile(candidates[0].product, candidates[0].variant);
    html += '</div>';
    slot.innerHTML = html;
    bindAddButtons();
  }

  /* ---- shared rendering ---- */

  function buildTile(product, variant) {
    var img = product.featuredImage
      ? '<img src="' + product.featuredImage + '" alt="' + product.title.replace(/"/g, '&quot;') + '">'
      : '';
    var packSize = variant.packSize
      ? '<p data-suggestion-pack-size>' + variant.packSize + '</p>'
      : '';
    return '<div data-suggestion-tile data-product-id="' + product.id + '">' +
      img +
      '<p>' + product.title + '</p>' +
      packSize +
      '<p data-suggestion-price>' + formatMoney(variant.price) + '</p>' +
      '<button data-suggestion-add data-variant-id="' + variant.id + '">Add</button>' +
      '</div>';
  }

  function bindAddButtons() {
    var buttons = slot.querySelectorAll('[data-suggestion-add]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (e) {
        e.preventDefault();
        this.disabled = true;
        addToCart(Number(this.getAttribute('data-variant-id')));
      });
    }
  }

  /* ---- boot ---- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
